/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import { m11ReportContainerFoiChanged, m11ReportContainerResourceChanged, m11ReportSection10FoiChanged, m11ReportSection10ResourceChanged, m11ResearchStudyResourceChanged, selectM11ReportContainerFoi, selectM11ReportContainerResource, selectM11ReportSection10Foi, selectM11ReportSection10Resource, selectM11ResearchStudyResource } from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import jsonEquals from "../../functions/jsonEquals";
import { StringKeyedEntry } from "../../datatypeComponents/StringEntry";
import ArrayEntry from "../../datatypeComponents/ArrayEntry";
import loadResource from "../m11ReportFunctions/loadResource";
import getIdFromReference from "../../functions/getIdFromReference";
import TextDivEntry from "./TextDivEntry";
import { Button } from "semantic-ui-react";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const savePrimaryObjectivesChanges = async (dispatch, apiToken, m11ResearchStudyFoi, primaryObjectivesState,
    objectiveDictionaryState, narrativeDictionaryState, setAlertModalState,
    setStartingPrimaryObjectivesState, setStartingObjectiveDictionaryState, setStartingNarrativeDictionaryState) => {

    if (primaryObjectivesState.notApplicable === true) {
        if (primaryObjectivesState.objectivesArray.length > 0) {
            alert("This will delete primary objectives content.")
        }
    }
    let changesStates = {
        primaryObjectivesState: primaryObjectivesState,
        objectiveDictionaryState: objectiveDictionaryState,
        narrativeDictionaryState: narrativeDictionaryState
    };
    let response = await saveM11Changes(apiToken, 9, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        let revisedObjectivesState = JSON.parse(JSON.stringify(primaryObjectivesState));
        if (response.m11ResearchStudyResource) {
            dispatch(m11ResearchStudyResourceChanged(response.m11ResearchStudyResource));
            if (response.m11ResearchStudyResource.objective) {
                revisedObjectivesState.objectivesArray = response.m11ResearchStudyResource.objective;
                for (const objective of revisedObjectivesState.objectivesArray) {
                    if (objective?.type?.coding?.[0]?.code === "primary") {
                        revisedObjectivesState.primaryObjectivesArray.push(objective);
                    }
                }
            }
        }
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection10Resource) {
            dispatch(m11ReportSection10ResourceChanged(response.m11ReportSection10Resource));
        }
        setStartingNarrativeDictionaryState(JSON.parse(JSON.stringify(narrativeDictionaryState)));
        setStartingObjectiveDictionaryState(JSON.parse(JSON.stringify(objectiveDictionaryState)));
        setStartingPrimaryObjectivesState(JSON.parse(JSON.stringify(revisedObjectivesState)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step009OtherPrimaryObjectives = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11User = useSelector(selectCurrentUserM11Use);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection10Foi = useSelector(selectM11ReportSection10Foi);
    const m11ReportSection10Resource = useSelector(selectM11ReportSection10Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [primaryObjectivesState, setPrimaryObjectivesState] = useState({
        "section104Heading": "", "section104Text": "",
        "section104Section": [], "objectivesArray": [], "primaryObjectivesArray": []
    });
    const [startingPrimaryObjectivesState, setStartingPrimaryObjectivesState] = useState({
        "section104Heading": "", "section104Text": "",
        "section104Section": [], "objectivesArray": [], "primaryObjectivesArray": []
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);
    const [expandObjectiveState, setExpandObjectiveState] = useState({});
    const [objectiveDictionaryState, setObjectiveDictionaryState] = useState({});
    const [startingObjectiveDictionaryState, setStartingObjectiveDictionaryState] = useState({});
    const [narrativeDictionaryState, setNarrativeDictionaryState] = useState({});
    const [startingNarrativeDictionaryState, setStartingNarrativeDictionaryState] = useState({});
    const [containedResourceDictionary, setContainedResourceDictionary] = useState({});

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource &&
            (!jsonEquals(primaryObjectivesState, startingPrimaryObjectivesState) ||
                !jsonEquals(objectiveDictionaryState, startingObjectiveDictionaryState) ||
                !jsonEquals(narrativeDictionaryState, startingNarrativeDictionaryState))),
        async saveAllChanges() {
            await savePrimaryObjectivesChanges(dispatch, apiToken, m11ResearchStudyFoi, primaryObjectivesState,
                objectiveDictionaryState, narrativeDictionaryState, setAlertModalState,
                setStartingPrimaryObjectivesState, setStartingObjectiveDictionaryState, setStartingNarrativeDictionaryState);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
            if (Array.isArray(m11ResearchStudyResource.contained) && m11ResearchStudyResource.contained.length > 0) {
                let containedResourceDictionary = {};
                for (const item of m11ResearchStudyResource.contained) {
                    const key = "#" + item.id;
                    containedResourceDictionary[key] = item;
                }
                setContainedResourceDictionary(containedResourceDictionary);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section104Heading": "", "section104Text": "",
                "section104Section": [], "objectivesArray": [], "primaryObjectivesArray": [],
                "loaded": true
            };
            if (m11ResearchStudyResource.objective) {
                startingData.objectivesArray = JSON.parse(JSON.stringify(m11ResearchStudyResource.objective));
                for (const objective of startingData.objectivesArray) {
                    if (objective?.type?.coding?.[0]?.code === "primary") {
                        startingData.primaryObjectivesArray.push(JSON.parse(JSON.stringify(objective)));
                    }
                }
            }
            if (startingData.primaryObjectivesArray?.length > 0) {
                let startingSet = {};
                let startingDictionary = {};
                for (const index in startingData.primaryObjectivesArray) {
                    startingSet[index] = false;
                    startingDictionary[index] = startingData.primaryObjectivesArray[index];
                }
                setExpandObjectiveState(startingSet);
                setObjectiveDictionaryState(startingDictionary);
                setStartingObjectiveDictionaryState(JSON.parse(JSON.stringify(startingDictionary)));
            }
            setPrimaryObjectivesState(startingData);
            setStartingPrimaryObjectivesState(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[10]?.entry?.length) {
                let m11ReportSection010Foi = getIdFromReference(m11ReportContainerResource.section[10].entry[0]);
                if (m11ReportSection010Foi && !isNaN(m11ReportSection010Foi) && m11ReportSection010Foi !== m11ReportSection10Foi) {
                    dispatch(m11ReportSection10FoiChanged(m11ReportSection010Foi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection10Foi && !isNaN(m11ReportSection10Foi)) {
            loadResource(m11ReportSection10Foi, "M11ReportSection10", apiToken, dispatch);
        }
    }, [m11ReportSection10Foi]);

    useEffect(() => {
        if (m11ReportSection10Resource && Object.keys(m11ReportSection10Resource).length > 0) {
            let startingData = {
                "section104Heading": "", "section104Text": "",
                "section104Section": [], "objectivesArray": [], "primaryObjectivesArray": [],
                "loaded": true
            };
            if (m11ResearchStudyResource.objective) {
                startingData.objectivesArray = JSON.parse(JSON.stringify(m11ResearchStudyResource.objective));
                for (const objective of startingData.objectivesArray) {
                    if (objective?.type?.coding?.[0]?.code === "primary") {
                        startingData.primaryObjectivesArray.push(JSON.parse(JSON.stringify(objective)));
                    }
                }
            }
            if (m11ReportSection10Resource.section?.[0]?.section?.[3]?.title) {
                startingData.section104Heading = m11ReportSection10Resource.section[0].section[3].title;
            }
            if (m11ReportSection10Resource.section?.[0]?.section?.[3]?.text) {
                startingData.section104Text = JSON.parse(JSON.stringify(m11ReportSection10Resource.section[0].section[3].text));
            }
            if (m11ReportSection10Resource.section?.[0]?.section?.[3]?.section?.length > 0) {
                startingData.section104Section = JSON.parse(JSON.stringify(m11ReportSection10Resource.section[0].section[3].section));
                if (startingData.primaryObjectivesArray?.length > 0) {
                    let startingSet = {};
                    let startingDictionary = {};
                    for (const index in startingData.primaryObjectivesArray) {
                        startingSet[index] = false;
                        startingDictionary[index] = startingData.primaryObjectivesArray[index];
                    }
                    setExpandObjectiveState(startingSet);
                    setObjectiveDictionaryState(startingDictionary);
                    setStartingObjectiveDictionaryState(JSON.parse(JSON.stringify(startingDictionary)));
                    if (startingData.section104Section?.length > 0) {
                        let startingNarrativeDictionary = {};
                        for (const index in startingData.section104Section) {
                            let entry = {
                                "section10411Xhtml": "",
                                "section10412Xhtml": "",
                                "section10413Xhtml": "",
                                "section10414Xhtml": "",
                                "section10415Xhtml": ""
                            }
                            if (startingData.section104Section[index]?.section?.length > 0) {
                                if (startingData.section104Section[index].section[0]?.text?.div) {
                                    entry.section10411Xhtml = startingData.section104Section[index].section[0].text.div;
                                }
                                if (startingData.section104Section[index].section[1]?.text?.div) {
                                    entry.section10412Xhtml = startingData.section104Section[index].section[1].text.div;
                                }
                                if (startingData.section104Section[index].section[2]?.text?.div) {
                                    entry.section10413Xhtml = startingData.section104Section[index].section[2].text.div;
                                }
                                if (startingData.section104Section[index].section[3]?.text?.div) {
                                    entry.section10414Xhtml = startingData.section104Section[index].section[3].text.div;
                                }
                                if (startingData.section104Section[index].section[4]?.text?.div) {
                                    entry.section10415Xhtml = startingData.section104Section[index].section[4].text.div;
                                }
                            }
                            startingNarrativeDictionary[index] = entry;
                        }
                        setNarrativeDictionaryState(startingNarrativeDictionary);
                        setStartingNarrativeDictionaryState(JSON.parse(JSON.stringify(startingNarrativeDictionary)));
                    }
                }
                setPrimaryObjectivesState(startingData);
                setStartingPrimaryObjectivesState(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection10Resource]);

    return <div>
        <div className="h3Style h3EntryLabel" style={{ marginBottom: "0px" }}>
            Enter Additional Primary Objectives.<span> This will be used in Sections 1 (Protocol Summary), 3 (Objectives and Estimands) and 10 (Statistical Considerations).</span>
        </div>
        {!(m11ReportSection10Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {m11User === "sample" ?
            <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
                <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
                <p style={{ color: "red" }}>Step 9 (Enter Additional Primary Objectives) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
                <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
            </div>
            :
            <>{
                primaryObjectivesState.loaded &&
                <>
                    {
                        objectiveDictionaryState && Object.keys(objectiveDictionaryState).length > 0 &&
                        Object.keys(objectiveDictionaryState).map((key, index) => {
                            let objective = objectiveDictionaryState[key];
                            return <div key={index}>
                                <h3>Primary Objective {index + 1} {objective.name}  <button style={{ cursor: "pointer", padding: "1px" }} onClick={() => {
                                    setExpandObjectiveState(prevState => { return { ...prevState, [index]: !expandObjectiveState[index] } });
                                }}>{expandObjectiveState[index] ? " ▼ collapse  " : " ► expand  "}</button></h3>
                                {expandObjectiveState[index] && <div>
                                    {objective && <>
                                        <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                                            <span>Enter a name or short label for Primary Objective {index + 1}.</span>
                                        </div>
                                        <StringKeyedEntry elementName='name'
                                            required={true}
                                            fieldLabel='Objective Name'
                                            startingValue={objectiveDictionaryState[key].name}
                                            index={index}
                                            setKeyedResourceState={setObjectiveDictionaryState} />
                                        <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                                            <span>Enter a nontechnical (layperson) description for Primary Objective {index + 1}.</span>
                                        </div>
                                        <StringKeyedEntry elementName='description'
                                            fieldLabel='Objective Description'
                                            startingValue={objectiveDictionaryState[key].description}
                                            index={index}
                                            setKeyedResourceState={setObjectiveDictionaryState} />
                                        <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                                            <span>Complete the Estimand Characteristics detail for each outcome and estimand for this objective. Click the </span>+Add Estimand<span> button to enter data for additional estimands.</span>
                                        </div>
                                        {!jsonEquals(objectiveDictionaryState[index], {
                                            "name": "",
                                            "description": "",
                                            "outcomeMeasure": []
                                        }) &&
                                            <ArrayEntry datatype="M11Estimand" elementName='outcomeMeasure'
                containedResourceDictionary={containedResourceDictionary}
                                                doNotShowFieldLabel={true}
                                                startCollapsed={true} startEmptyArrayClosed={false}
                                                deletable={true} fieldLabel='Estimand'
                                                startingValue={objectiveDictionaryState[key].outcomeMeasure || []}
                                                index={index}
                                                setKeyedResourceState={setObjectiveDictionaryState} />
                                        }
                                    </>}
                                    <div className="h3Style h3EntryLabel" style={{ marginBottom: "0px" }}>
                                        Complete Section 10.4.{index + 1} Primary Objective {index + 1} (Statistical Considerations).
                                    </div>
                                    {narrativeDictionaryState[index] && <>
                                        <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                                            <span>Revise the </span>Section 10.4.{index + 1}.1 Statistical Analysis Method<span> as needed.</span>
                                        </div>
                                        <TextDivEntry elementName="section10411Xhtml"
                                            startingValue={narrativeDictionaryState[index].section10411Xhtml}
                                            index={index}
                                            setKeyedResourceState={setNarrativeDictionaryState} />
                                        <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                                            <span>Revise the </span>Section 10.4.{index + 1}.2 Handling of Data in Relation to Primary Estimand(s)<span> as needed.</span>
                                        </div>
                                        <TextDivEntry elementName="section10412Xhtml"
                                            startingValue={narrativeDictionaryState[index].section10412Xhtml}
                                            index={index}
                                            setKeyedResourceState={setNarrativeDictionaryState} />
                                        <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                                            <span>Revise the </span>Section 10.4.{index + 1}.3 Handling of Missing Data in Relation to Primary Estimand(s)<span> as needed.</span>
                                        </div>
                                        <TextDivEntry elementName="section10413Xhtml"
                                            startingValue={narrativeDictionaryState[index].section10413Xhtml}
                                            index={index}
                                            setKeyedResourceState={setNarrativeDictionaryState} />
                                        <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                                            <span>Revise the </span>Section 10.4.{index + 1}.4 Sensitvity Analysis<span> as needed.</span>
                                        </div>
                                        <TextDivEntry elementName="section10414Xhtml"
                                            startingValue={narrativeDictionaryState[index].section10414Xhtml}
                                            index={index}
                                            setKeyedResourceState={setNarrativeDictionaryState} />
                                        <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                                            <span>Revise the </span>Section 10.4.{index + 1}.5 Supplementary Analysis<span> as needed.</span>
                                        </div>
                                        <TextDivEntry elementName="section10415Xhtml"
                                            startingValue={narrativeDictionaryState[index].section10415Xhtml}
                                            index={index}
                                            setKeyedResourceState={setNarrativeDictionaryState} />
                                    </>}
                                </div>}
                            </div>
                        })
                    }
                    <div style={{ marginBottom: "12px" }}>
                        {(objectiveDictionaryState && primaryObjectivesState.primaryObjectivesArray) &&
                            <>
                                <Button className="formButton" style={{ color: "#000000" }}
                                    content={"+ Add Another Primary Objective"}
                                    onClick={() => {
                                        let newIndex = primaryObjectivesState.primaryObjectivesArray.length || 1;
                                        setExpandObjectiveState(prevState => { return { ...prevState, [newIndex]: true } });
                                        setObjectiveDictionaryState(prevState => {
                                            return {
                                                ...prevState,
                                                [newIndex]: {
                                                    "name": "",
                                                    "description": "",
                                                    "outcomeMeasure": []
                                                }
                                            };
                                        });
                                        setNarrativeDictionaryState(prevState => {
                                            return {
                                                ...prevState,
                                                [newIndex]: {
                                                    "section10411Xhtml": "",
                                                    "section10412Xhtml": "",
                                                    "section10413Xhtml": "",
                                                    "section10414Xhtml": "",
                                                    "section10415Xhtml": ""
                                                }
                                            };
                                        });
                                    }} />
                            </>}
                    </div>
                </>
            }</>
        }
    </div>
});

const M11Step009OtherPrimaryObjectivesHelperText = <div>
    <h3>Enter Additional Primary Objectives</h3>
    <div style={{ textAlign: "left" }}>
        <p>Enter detail to add an additional primary objective, or proceed to Step 10 if there are no additional primary objectives to add, or proceed to Step 12 if there are no additional objectives to add.</p>
        <p>Enter a name or short label for the Additional Objective. This will be used in the M11 Report Section 1 Protocol Summary.</p>
        <p>Enter a nontechnical (layperson) description for the Additional Objective. If provided, this will be used in the M11 Report Section 1 Protocol Summary.</p>
        <p>Complete the Estimand Characteristics detail for each outcome and estimand for this objective. Click the +Add Estimand button to enter data for additional estimands.</p>
        <h3>Complete Section 10.4.X Primary Objective X (Statistical Considerations)</h3>
        <div style={{ textAlign: "left" }}>
            <p>Enter data for Section 10.4.X.1 Statistical Analysis Method.</p>
            <div style={{ marginLeft: "24px" }} >
                <p>Describe the statistical analysis methods that will be used to evaluate this primary objective and associated estimand(s) in Section 3.1.1 Primary Objective 1 and Associated Estimand(s). Ensure that the statistical hypothesis/model/analysis (and corresponding assumptions) is aligned with the primary estimand(s).</p>
                <p>When applicable, state the null and alternative hypotheses, including the pre-planned type 1 error rate, or alternative criteria for evaluating whether the objective has been met, and relevant operating characteristics if appropriate. Describe the statistical model used and the factors that will be included (e.g., covariates and interactions) and any rules for handling these factors (e.g., pooling of centres).</p>
                <p>If modelling and simulation methods are to be used, describe the model (inputs and outputs), the underlying assumptions, and the method of model fitting.</p>
            </div>
            <p>Enter data for Section 10.4.X.2 Handling of Data in Relation to Primary Estimand(s).</p>
            <div style={{ marginLeft: "24px" }} >
                <p>For each intercurrent event of the primary estimand(s) defined in Section 3.1.1 Primary Objective(s) and Associated Estimand(s), explain how data will be handled for the statistical analysis in line with the primary estimand. The handling of intercurrent events in the statistical analysis should be aligned with the specific estimand strategies being used.</p>
                <p>This section should describe in more detail the rationale and handling of the data rather than repeating information from the preceding sections.</p>
            </div>
            <p>Enter data for Section 10.4.X.3 Handling of Missing Data in Relation to Primary Estimand(s).</p>
            <div style={{ marginLeft: "24px" }} >
                <p>Describe how missing data will be addressed (e.g., imputation method and model), state the underlying assumptions, and provide a rationale for the approach.</p>
            </div>
            <p>If applicable, enter data for Section 10.4.X.4 Sensitivity Analysis.</p>
            <div style={{ marginLeft: "24px" }} >
                <p>Describe any sensitivity analyses and how their assumptions changed from the assumptions of the main statistical analysis. Sensitivity analyses are a series of analyses conducted with the intent to explore the robustness of inferences from the main estimator to deviations from its underlying modelling assumptions and limitations in the data.</p>
            </div>
            <p>If applicable, enter data for Section 10.4.X.5 Supplementary Analysis.</p>
            <div style={{ marginLeft: "24px" }} >
                <p>Describe any supplementary analysis, if applicable. Supplementary analyses are conducted in addition to the main and sensitivity analyses with the intent to provide additional insights into the understanding of the treatment effect.</p>
            </div>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step009OtherPrimaryObjectivesValidationCheck = ({ }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [validationCheckState, setValidationCheckState] = useState({});

    useEffect(() => {
        if (m11ResearchStudyFoi) {
            validateStep(apiToken, 9, m11ResearchStudyFoi,
                setValidationCheckState)
        }
    }, [m11ResearchStudyFoi]);

    return <div>{validationCheckState?.success && <div>
        <h4>Step 9 (Enter Additional Primary Objectives) {validationCheckState.step09numberOfChecks} issues checked. {validationCheckState.step09numberPassed} passed. {validationCheckState.step09numberFailed} failed.</h4>
        <p>All primary objectives have a description: {validationCheckState.resultCheckObjectiveDescriptionAllPrimary}</p>
        <p>All primary objectives have at least one associated estimand: {validationCheckState.resultCheckObjectiveHasEstimandAllPrimary}</p>
        <p>Each estimand has an Endpoint description: {validationCheckState.resultCheckEstimandHasEndpointAllPrimary}</p>
        <p>Section 10.4 heading is 'Analyses Associated with the Primary Objective(s)': {validationCheckState.resultCheckSection104Heading}</p>
        <p>Section 10.4 Analyses Associated with the Primary Objective(s) does not have text: {validationCheckState.resultCheckSection104Text}</p>
        <p>Section 10.4.1 heading is 'Primary Objective 1' or 'Primary Objective' if only one primary objective: {validationCheckState.resultCheckSection1041Heading}</p>
        <p>Section 10.4.1 Primary Objective 1 does not have text: {validationCheckState.resultCheckSection1041Content}</p>
        <p>Section 10.4.1.1 heading is 'Statistical Analysis Method': {validationCheckState.resultCheckSection10411Heading}</p>
        <p>Section 10.4.1.1 Statistical Analysis Method has content: {validationCheckState.resultCheckSection10411Content}</p>
        <p>Section 10.4.1.2 heading is 'Handling of Data in Relation to Primary Estimand(s)': {validationCheckState.resultCheckSection10412Heading}</p>
        <p>Section 10.4.1.2 Handling of Data in Relation to Primary Estimand(s) has content: {validationCheckState.resultCheckSection10412Content}</p>
        <p>Section 10.4.1.3 heading is 'Handling of Missing Data in Relation to Primary Estimand(s)': {validationCheckState.resultCheckSection10413Heading}</p>
        <p>Section 10.4.1.3 Handling of Missing Data in Relation to Primary Estimand(s) has content: {validationCheckState.resultCheckSection10413Content}</p>
        <p>If present, Section 10.4.1.4 heading is 'Sensitivity Analysis': {validationCheckState.resultCheckSection10414Heading}</p>
        <p>If present, Section 10.4.1.4 Sensitivity Analysis has content: {validationCheckState.resultCheckSection10414Content}</p>
        <p>If present, Section 10.4.1.5 heading is 'Supplementary Analysis': {validationCheckState.resultCheckSection10415Heading}</p>
        <p>If present, Section 10.4.1.5 Supplementary Analysis has content: {validationCheckState.resultCheckSection10415Content}</p>
        <p>If present, Section 10.4.X heading is 'Primary Objective X': {validationCheckState.resultCheckSection104XHeading}</p>
        <p>If present, Section 10.4.X Primary Objective X does not have text: {validationCheckState.resultCheckSection104XContent}</p>
        <p>If Section 10.4.X is present, Section 10.4.X.1 heading is 'Statistical Analysis Method': {validationCheckState.resultCheckSection104X1Heading}</p>
        <p>If Section 10.4.X is present, Section 10.4.X.1 Statistical Analysis Method has content: {validationCheckState.resultCheckSection104X1Content}</p>
        <p>If Section 10.4.X is present, Section 10.4.X.2 heading is 'Handling of Data in Relation to Primary Estimand(s)': {validationCheckState.resultCheckSection104X2Heading}</p>
        <p>If Section 10.4.X is present, Section 10.4.X.2 Handling of Data in Relation to Primary Estimand(s) has content: {validationCheckState.resultCheckSection104X2Content}</p>
        <p>If Section 10.4.X is present, Section 10.4.X.3 heading is 'Handling of Missing Data in Relation to Primary Estimand(s)': {validationCheckState.resultCheckSection104X3Heading}</p>
        <p>If Section 10.4.X is present, Section 10.4.X.3 Handling of Missing Data in Relation to Primary Estimand(s) has content: {validationCheckState.resultCheckSection104X3Content}</p>
        <p>If present, Section 10.4.X.4 heading is 'Sensitivity Analysis': {validationCheckState.resultCheckSection104X4Heading}</p>
        <p>If present, Section 10.4.X.4 Sensitivity Analysis has content: {validationCheckState.resultCheckSection104X4Content}</p>
        <p>If present, Section 10.4.X.5 heading is 'Supplementary Analysis': {validationCheckState.resultCheckSection104X5Heading}</p>
        <p>If present, Section 10.4.X.5 Supplementary Analysis has content: {validationCheckState.resultCheckSection104X5Content}</p>
    </div>}  </div>
}

export default M11Step009OtherPrimaryObjectives;
export { M11Step009OtherPrimaryObjectivesHelperText, M11Step009OtherPrimaryObjectivesValidationCheck };